import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { PrimeNG } from 'primeng/config';
import Lara from '@primeuix/themes/lara';
import { addPresetsToTheme } from '../../theme/theme-presets';

export interface AppConfig {
  environment: string;
  defaultIdleSeconds: number;
}

@Injectable({
  providedIn: 'root'
})
export class AppInitializerService {
  constructor(
    private config: PrimeNG,
    @Inject(DOCUMENT) private document: Document
  ) {}

  /**
   * Initialize the application: set theme and detect environment
   */
  initialize(): AppConfig {
    this.setupTheme();
    const environment = this.detectEnvironment();
    const defaultIdleSeconds = environment === 'local' || environment === 'dev' 
      ? 60 * 60  // 1 hour for dev
      : 15 * 60; // 15 minutes for prod

    return { environment, defaultIdleSeconds };
  }

  /**
   * Detect the current environment from the URL
   */
  private detectEnvironment(): string {
    const url = this.document.location.href;

    if (
      url.includes('develope.perifor.com') ||
      url.includes('develop.perifor') ||
      url.includes('perifor-dev')
    ) {
      return 'dev';
    }
    if (url.includes('uat.perifor.com') || url.includes('perifor-uat')) {
      return 'uat';
    }
    if (url.includes('localhost')) {
      return 'local';
    }

    return 'unknown';
  }

  /**
   * Set up PrimeNG theme with Tailwind integration
   */
  private setupTheme(): void {
    this.config.theme.set({
      preset: addPresetsToTheme(Lara),
      options: {
        darkModeSelector: '.perifor-app-dark',
        cssLayer: {
          name: 'primeng',
          order: 'tailwind-base, primeng, tailwind-utilities'
        }
      }
    });
  }
}
